import {Injectable} from '@angular/core';
import {ApiClientService} from './api-client.service';
import {Classified} from '../types/data.types';
import {UrlService} from './url.service';
import {EmptyRowService} from './empty-row.service';
import {ConstantsService} from './constants.service';

declare const toastr: any;
declare const swal: any;
declare const $: any;

@Injectable()
export class ClassifiedsService {
    isClassifiedsModalShow = false;
    // returnKeyModal = false;
    // signOutKeyModal = false;
    // showHistoryModal = false;

    classifiedInClassifiedModal: Classified;

    data = {
        allClassifieds: {
            get: '/v1/key_log.json?expand=building,suite,resident,incidentReportType,createdBy,activities',
            data: [],
            total: null
        },
    };
    tabId = 'classified';
    spinnerShow = true;
    buildings: Array<any> = [];

    constructor(
        public api: ApiClientService,
        public urlService: UrlService,
        public emptyRowService: EmptyRowService,
    ) {
        this.api.onLogout.subscribe(() => this.buildings = []);
    }

    getData() {
        this.spinnerShow = true;
        this.data[this.tabId].total = null;

        const tabId = this.urlService.queryParams['tab'];
        const url = this.data[tabId].get;
        const queryParams = this.urlService.getQueryParamsString();

        this.api.get('domainClassifieds', `${url}${queryParams}`).subscribe(
            (res) => {
                const body = JSON.parse(res._body);
                const entities = body.entities;
                this.data[tabId].data = [];
                this.data[tabId].total = body.total;
                this.emptyRowService.fillEmptyRow();
                this.classifiedsFactory(entities, this.data[tabId].data);
                this.spinnerShow = false;
            },
            (error) => this.api.errorHandler(error, 'Failed to get Classifieds')
        );
    }

    classifiedsFactory(entities: any, targetArray) {
        entities.forEach((classfd) => targetArray.push(Classified.fromExistingData(classfd))); // @todo after every iteration it will call change detector. it is very bad practice!
    }

    getBuildings(): void {
        if (this.buildings.length) return;
        const url = `/v1/buildings.json?per-page=1000&order-by=name|asc`;
        this.api.get('domainBD', url).subscribe(
            (res) => this.buildings = JSON.parse(res._body).entities,
            (error) => this.api.errorHandler(error, 'Failed get buildings')
        );
    }

    resetData() {
        for (const item in this.data) {
            this.data[item].data = [];
            this.data[item].total = null;
        }
    }

    signOutKey(classified: Classified) {
        // this.signOutKeyModal   = true;
        this.classifiedInClassifiedModal = Object.assign({}, classified);
    }

    returnKey(classified: Classified) {
        // this.returnKeyModal   = true;
        this.classifiedInClassifiedModal = Object.assign({}, classified);
    }

    deleteKeyLog(classified: Classified): void {
        if (!classified.id) return;
        swal(ConstantsService.getSwalConfig('Delete Key Log'),
            () => {
                const url = `/v1/key_log/${classified.id}.json`;
                this.api.remove('domainClassifieds', url).subscribe(
                    () => {
                        toastr.success('Classified has been deleted.');
                        this.getData();
                    },
                    (error) => this.api.errorHandler(error, 'Delete Classified failed')
                );
            }
        );
    }

    getHistory(classified: Classified): void {
        // this.showHistoryModal = true;
        this.classifiedInClassifiedModal = Object.assign({}, classified);
    }

}



// WEBPACK FOOTER //
// /app/src/app/services/classifieds.service.ts